// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uYrXtwYQZtJpSmB8rs2z {
  display: none;
}

@media screen and (max-width: 768px) {
  .uYrXtwYQZtJpSmB8rs2z {
    display: flex;
    margin-top: 2rem;
    justify-content: space-around;
    width: 100%;
  }
  .uYrXtwYQZtJpSmB8rs2z a {
    display: flex;
    justify-content: center;
    align-items: center;
    color: whitesmoke;
    font-size: 1.5rem;
    transition: color 0.3s ease;
    width: 2.2rem;
    height: 2.2rem;
    margin: 0;
    padding: 0;
    background-color: #1e254a;
    border-radius: 10%;
    z-index: 1000;
  }
  .uYrXtwYQZtJpSmB8rs2z a:hover {
    color: #1e254a;
    background-color: whitesmoke;
    border-radius: 10%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SocialMedia/SocialMediaMobile.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAEA;EACI;IACI,aAAA;IACA,gBAAA;IACA,6BAAA;IACA,WAAA;EACN;EAAM;IACI,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,iBAAA;IACA,iBAAA;IACA,2BAAA;IACA,aAAA;IACA,cAAA;IACA,SAAA;IACA,UAAA;IACA,yBAAA;IACA,kBAAA;IACA,aAAA;EAEV;EAAU;IACI,cAAA;IACA,4BAAA;IACA,kBAAA;EAEd;AACF","sourcesContent":[".socialMedia {\n    display: none;\n}\n\n@media screen and (max-width: 768px) {\n    .socialMedia {\n        display: flex;\n        margin-top: 2rem;\n        justify-content: space-around;\n        width: 100%;\n        a {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            color: whitesmoke;\n            font-size: 1.5rem;\n            transition: color 0.3s ease;\n            width: 2.2rem;\n            height: 2.2rem;\n            margin: 0;\n            padding: 0;\n            background-color: #1e254a;\n            border-radius: 10%;\n            z-index: 1000;\n    \n            &:hover {\n                color: #1e254a;\n                background-color: whitesmoke;\n                border-radius: 10%;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"socialMedia": `uYrXtwYQZtJpSmB8rs2z`
};
export default ___CSS_LOADER_EXPORT___;
